import __decorate from "../_virtual/_@oxc-project_runtime@0.147.0/helpers/esm/decorate.js";
import { css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { msg } from "@lit/localize";
import { PdConfirmDialog } from "@progressive-development/pd-dialog";
//#region src/wizard-close-popup/WizardClosePopup.ts
/**
* WizardClosePopup - Confirmation dialog for closing a wizard
*
* Displays a warning dialog when user attempts to close a wizard,
* with options to save progress (if storage enabled) or discard changes.
*
* @example
* ```typescript
* const popup = new WizardClosePopup();
* popup.withStorage = true;
* popup.confirmButtonText = "Save";
* popup.cancelButtonText = "Discard";
*
* popup.addEventListener("pd-dialog-confirm", () => {
*   // User chose to save/close
* });
*
* popup.addEventListener("pd-dialog-cancel", () => {
*   // User chose to discard
* });
*
* this.shadowRoot.appendChild(popup);
* ```
*/
var WizardClosePopup = class WizardClosePopup extends PdConfirmDialog {
	constructor(..._args) {
		super(..._args);
		this._singleButton = false;
		this._dialogType = "warn";
		this._dialogTitle = msg("Änderungen verwerfen?", { id: "pdWizard.close.popup.title" });
		this.withStorage = false;
	}
	static {
		this.styles = [PdConfirmDialog.styles, css`
      .popup-content {
        display: flex;
        flex-direction: column;
      }
    `];
	}
	_renderContent() {
		return html`
      <div class="popup-content">
        <p>
          ${this.withStorage ? msg("Eingaben für später speichern oder verwerfen?", { id: "pdWizard.close.popup.storage.content" }) : msg("Nicht gespeicherte Daten gehen verloren.", { id: "pdWizard.close.popup.noStorage.content" })}
        </p>
      </div>
    `;
	}
};
__decorate([property({ type: Boolean })], WizardClosePopup.prototype, "withStorage", void 0);
WizardClosePopup = __decorate([customElement("wizard-close-popup")], WizardClosePopup);
//#endregion
export { WizardClosePopup };
